import { render, staticRenderFns } from "./purchase-confirm-announcement.html?vue&type=template&id=355382d1&scoped=true&external"
import script from "./purchase-confirm-announcement.js?vue&type=script&lang=js&external"
export * from "./purchase-confirm-announcement.js?vue&type=script&lang=js&external"
import style0 from "./purchase-confirm-announcement.scss?vue&type=style&index=0&id=355382d1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355382d1",
  null
  
)

export default component.exports